import axiosInstance from './axiosConfig';
import { AddPixelTag, PixelTag, PixelTagCodeResponse } from '../types/pixel-tag';

export const getPixelTags = async () => {
    const response = await axiosInstance.get<PixelTag[]>('/pixel-tag');
    return response?.data;
};

export const getPixelTag = async (id: string) => {
    const response = await axiosInstance.get<PixelTag>(`/pixel-tag/${id}`);
    return response?.data;
};

export const getPixelTagCode = async (id: string, format: 'html' | 'js' | 'gtm' | 'postback_url' | 'postback_s2s' = 'html') => {
    const response = await axiosInstance.get<PixelTagCodeResponse>(`/pixel-tag/${id}/code?format=${format}`);
    return response?.data;
};

export const createPixelTag = async (pixelTag: AddPixelTag) => {
    const response = await axiosInstance.post<PixelTag>('/pixel-tag', pixelTag);
    return response?.data;
};

export const updatePixelTag = async (id: string, pixelTag: Partial<PixelTag>) => {
    const response = await axiosInstance.patch<PixelTag>(`/pixel-tag/${id}`, pixelTag);
    return response?.data;
};

export const deletePixelTag = async (id: string) => {
    const response = await axiosInstance.delete(`/pixel-tag/${id}`);
    return response?.data;
};
